export function geolocation(options?: PositionOptions): Promise<GeolocationPosition> {
  return new Promise((resolve, reject) =>
    navigator.geolocation.getCurrentPosition(
      (position: GeolocationPosition) => resolve(position),
      (positionError: GeolocationPositionError) => reject(positionError),
      options
    )
  );
}
